import { OkThxWordmark } from "@/components/icons/Logo.tsx";

/**
 * The nav for pages served without a session: the wordmark, linking home.
 *
 * Every public view must pass this to `SiteHeaderContent` as `NavComponent`.
 * The default is {@link LogoNav}, which calls `useContactProfilesEnabled` and so
 * issues a `/api/a/...` request — on a signed-out page that 401s, and the global
 * response interceptor turns any 401 from our API into a redirect to `/auth`.
 * The page's own public data loads fine; the visitor still lands on the login
 * screen.
 */
export const PublicLogoNav = () => {
  const handleLogoClick = () => {
    window.location.href = "/";
  };

  return (
    <OkThxWordmark
      cursor="pointer"
      pointerEvents="auto"
      role="button"
      onClick={handleLogoClick}
      className="ml-4"
    />
  );
};
